import React from "react";

// Card components
export { Card, CardHeader, CardBody, CardFooter } from "./Card";

// Typography
export { Typography } from "./Typography";

// List components
export { List, ListItem, ListItemPrefix, ListItemSuffix } from "./List";

// Accordion components
export { Accordion, AccordionHeader, AccordionBody } from "./Accordion";

// Menu components
export { Menu, MenuHandler, MenuList, MenuItem } from "./Menu";

// Button components
export { Button } from "./Button";
export { IconButton } from "./IconButton";

// Avatar
export { Avatar } from "./Avatar";

// Navbar
export { Navbar } from "./Navbar";

// Chip
export { Chip } from "./Chip";

// Tooltip
export { Tooltip } from "./Tooltip";

// ThemeProvider (no-op replacement for compatibility)
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};